<template>
<div>  
  <b-modal v-model="showError" :hide-header=true body-bg-variant="dark" body-text-variant="light"
  footer-bg-variant="dark" footer-text-variant="light" :ycentered=true size="lg">
    <p>{{ errorText }}</p>
    <div slot="modal-footer">
      <b-button variant="secondary" class="modal-btn" @click="ok">OK</b-button>
    </div>
  </b-modal> 
</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ErrorModal",
  props: {          
  },    
  computed: {
    ...mapState({
      errorText: state => state.error,      
    }),
    showError: {
        set(val) {          
          this.$store.commit('setShowError', val);
        }, 
        get () {          
          if(this.$store.state.error) {
            console.log('error text is: ' + this.$store.state.error);
            return this.$store.state.showError;
          }
        }
      } 
  },
  methods: {
    ok() {
      this.showError = !this.showError;
    }
  }
};
</script>
